// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ActiveStorageAttachment from "./active-storage-attachment.js"
import Contact from "./contact.js"
import PhotoSession from "./photo-session.js"
import PhotoSessionGroup from "./photo-session-group.js"
import PhotoSessionGroupContact from "./photo-session-group-contact.js"
import PhotoType from "./photo-type.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_identifier": {
      "column": {
        "default": null,
        "name": "photo_identifier",
        "null": true,
        "type": "string"
      },
      "name": "photo_identifier",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_group_id": {
      "column": {
        "default": null,
        "name": "photo_session_group_id",
        "null": true,
        "type": "uuid"
      },
      "name": "photo_session_group_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_group_contact_id": {
      "column": {
        "default": null,
        "name": "photo_session_group_contact_id",
        "null": true,
        "type": "uuid"
      },
      "name": "photo_session_group_contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "rating": {
      "column": {
        "default": null,
        "name": "rating",
        "null": true,
        "type": "integer"
      },
      "name": "rating",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "analyzed": {
      "column": null,
      "name": "analyzed",
      "selected_by_default": false,
      "translated": null
    },
    "content_type": {
      "column": null,
      "name": "content_type",
      "selected_by_default": false,
      "translated": null
    },
    "height": {
      "column": null,
      "name": "height",
      "selected_by_default": false,
      "translated": null
    },
    "full_size_url": {
      "column": null,
      "name": "full_size_url",
      "selected_by_default": false,
      "translated": null
    },
    "thumbnail_url": {
      "column": null,
      "name": "thumbnail_url",
      "selected_by_default": false,
      "translated": null
    },
    "width": {
      "column": null,
      "name": "width",
      "selected_by_default": false,
      "translated": null
    },
    "url": {
      "column": null,
      "name": "url",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Photo",
  "collectionKey": "photos",
  "collectionName": "photos",
  "i18nKey": "photo",
  "camelizedLower": "photo",
  "name": "Photo",
  "nameDasherized": "photo",
  "pluralName": "photos",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "attachment_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "attachment_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "attachment_attachment"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoColor",
      "collectionName": "photo_colors",
      "foreignKey": "photo_color_id",
      "name": "photo_color",
      "macro": "belongs_to",
      "resource_name": "PhotoColor",
      "through": null
    },
    {
      "className": "PhotoPhotoType",
      "collectionName": "photo_photo_types",
      "foreignKey": "photo_id",
      "name": "photo_photo_types",
      "macro": "has_many",
      "resource_name": "PhotoPhotoType",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "has_one",
      "resource_name": "PhotoSession",
      "through": "photo_session_group"
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_session_group_contact",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLineBox",
      "collectionName": "photo_sheet_product_order_line_boxes",
      "foreignKey": "photo_id",
      "name": "photo_sheet_product_order_line_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLineBox",
      "through": null
    },
    {
      "className": "PhotoType",
      "collectionName": "photo_types",
      "foreignKey": "photo_type_id",
      "name": "photo_types",
      "macro": "has_many",
      "resource_name": "PhotoType",
      "through": "photo_photo_types"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "uploaded_by_id",
      "name": "uploaded_by",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_color_id",
      "column": {
        "default": null,
        "name": "photo_color_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "photo_identifier",
      "column": {
        "default": null,
        "name": "photo_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "photo_session_group_contact_id",
      "column": {
        "default": null,
        "name": "photo_session_group_contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "photo_session_group_id",
      "column": {
        "default": null,
        "name": "photo_session_group_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "rating",
      "column": {
        "default": null,
        "name": "rating",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "uploaded_by_id",
      "column": {
        "default": null,
        "name": "uploaded_by_id",
        "null": false,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "attachment_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "has_one",
      "resource_name": "PhotoSession",
      "through": "photo_session_group"
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_session_group_contact",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "PhotoType",
      "collectionName": "photo_types",
      "foreignKey": "photo_type_id",
      "name": "photo_types",
      "macro": "has_many",
      "resource_name": "PhotoType",
      "through": "photo_photo_types"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "uploaded_by_id",
      "name": "uploaded_by",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "photo",
  "primaryKey": "id"
}

/** Frontend model for Photo. */
export default class Photo extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoIdentifier() {
    return this.readAttributeUnderscore("photo_identifier")
  }

  /** @returns {boolean} */
  hasPhotoIdentifier() {
    const value = this.photoIdentifier()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoSessionGroupId() {
    return this.readAttributeUnderscore("photo_session_group_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionGroupId() {
    const value = this.photoSessionGroupId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoSessionGroupContactId() {
    return this.readAttributeUnderscore("photo_session_group_contact_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionGroupContactId() {
    const value = this.photoSessionGroupContactId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  rating() {
    return this.readAttributeUnderscore("rating")
  }

  /** @returns {boolean} */
  hasRating() {
    const value = this.rating()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  analyzed() {
    return this.readAttributeUnderscore("analyzed")
  }

  /** @returns {boolean} */
  hasAnalyzed() {
    const value = this.analyzed()

    return this._isPresent(value)
  }

  /** @returns {any} */
  contentType() {
    return this.readAttributeUnderscore("content_type")
  }

  /** @returns {boolean} */
  hasContentType() {
    const value = this.contentType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  height() {
    return this.readAttributeUnderscore("height")
  }

  /** @returns {boolean} */
  hasHeight() {
    const value = this.height()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fullSizeUrl() {
    return this.readAttributeUnderscore("full_size_url")
  }

  /** @returns {boolean} */
  hasFullSizeUrl() {
    const value = this.fullSizeUrl()

    return this._isPresent(value)
  }

  /** @returns {any} */
  thumbnailUrl() {
    return this.readAttributeUnderscore("thumbnail_url")
  }

  /** @returns {boolean} */
  hasThumbnailUrl() {
    const value = this.thumbnailUrl()

    return this._isPresent(value)
  }

  /** @returns {any} */
  width() {
    return this.readAttributeUnderscore("width")
  }

  /** @returns {boolean} */
  hasWidth() {
    const value = this.width()

    return this._isPresent(value)
  }

  /** @returns {any} */
  url() {
    return this.readAttributeUnderscore("url")
  }

  /** @returns {boolean} */
  hasUrl() {
    const value = this.url()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static upload(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "upload",
        collectionName: "photos",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static uploadAndReplace(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "upload_and_replace",
        collectionName: "photos",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceProcessVariants(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_process_variants",
        collectionName: "photos",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceAnalyzeMissingWidthAndHeight(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_analyze_missing_width_and_height",
        collectionName: "photos",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./active-storage-attachment.js").default | null} */
  attachmentAttachment() {
    return this._readHasOneReflection({modelClass: ActiveStorageAttachment, reflectionName: "attachment_attachment"})
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  loadAttachmentAttachment() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["record_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "attachment_attachment",
        model: this,
        modelClass: ActiveStorageAttachment
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  ensureAttachmentAttachmentLoaded() {
    return this.ensureAssociationLoaded("attachment_attachment")
  }

  /** @returns {import("./photo-session.js").default | null} */
  photoSession() {
    return this._readHasOneReflection({modelClass: PhotoSession, reflectionName: "photo_session"})
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  loadPhotoSession() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "photo_session",
        model: this,
        modelClass: PhotoSession
      },
      {
        params: {
          through: {
            model: "Photo",
            id,
            reflection: "photo_session"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  ensurePhotoSessionLoaded() {
    return this.ensureAssociationLoaded("photo_session")
  }

  /** @returns {import("./photo-session-group.js").default | null} */
  photoSessionGroup() {
    return this._readBelongsToReflection({modelClass: PhotoSessionGroup, reflectionName: "photo_session_group"})
  }

  /** @returns {Promise<import("./photo-session-group.js").default | null>} */
  loadPhotoSessionGroup() {
    if (!("photoSessionGroupId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionGroupId")

    const id = this.photoSessionGroupId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session_group",
        model: this,
        modelClass: PhotoSessionGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session-group.js").default | null>} */
  ensurePhotoSessionGroupLoaded() {
    return this.ensureAssociationLoaded("photo_session_group")
  }

  /** @returns {import("./photo-session-group-contact.js").default | null} */
  photoSessionGroupContact() {
    return this._readBelongsToReflection({modelClass: PhotoSessionGroupContact, reflectionName: "photo_session_group_contact"})
  }

  /** @returns {Promise<import("./photo-session-group-contact.js").default | null>} */
  loadPhotoSessionGroupContact() {
    if (!("photoSessionGroupContactId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionGroupContactId")

    const id = this.photoSessionGroupContactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session_group_contact",
        model: this,
        modelClass: PhotoSessionGroupContact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session-group-contact.js").default | null>} */
  ensurePhotoSessionGroupContactLoaded() {
    return this.ensureAssociationLoaded("photo_session_group_contact")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./photo-type.js").default>} */
  photoTypes() {
    return new Collection(
      {
        reflectionName: "photo_types",
        model: this,
        modelClass: PhotoType
      },
      {
        params: {
          through: {
            model: "Photo",
            id: this.primaryKey(),
            reflection: "photo_types"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./photo-type.js").default>>} */
  loadPhotoTypes() {
    return this._loadHasManyReflection(
      {
        reflectionName: "photo_types",
        model: this,
        modelClass: PhotoType
      },
      {
        params: {
          through: {
            model: "Photo",
            id: this.primaryKey(),
            reflection: "photo_types"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./photo-type.js").default>>} */
  ensurePhotoTypesLoaded() {
    return this.ensureAssociationLoaded("photo_types")
  }

  /** @returns {import("./contact.js").default | null} */
  uploadedBy() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "uploaded_by"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadUploadedBy() {
    if (!("uploadedById" in this)) throw new Error("Foreign key method wasn't defined: uploadedById")

    const id = this.uploadedById()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "uploaded_by",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureUploadedByLoaded() {
    return this.ensureAssociationLoaded("uploaded_by")
  }
}
